<div
  appModal
  [closeOnClickOutside]="false"
  mainClass="small-modal show-overflow p-20"
  [showCloseButton]="false"
  (closeModal)="close()"
>
  <div class="text-center mb-10">
    <img
      [src]="eventData?.logo?.urlThumb || '/assets/images/rebrand/nextpro-logo.png'"
      alt="{{ eventData?.name }}"
      class="event__avatar logo-bg"
    />
  </div>
  <h4 class="tip__title flex flex-col justify-center items-center mb-30">
    <span class="text-center">Select your {{ subject }} to access {{ eventData?.name }}</span>
  </h4>

  <ng-container *ngIf="showEdit">
    <form [formGroup]="teamsForm" *ngIf="teamsForm">
      <ng-select
        [items]="teams"
        bindLabel="name"
        bindValue="value"
        formControlName="0"
        placeholder="Select {{ subject === 'team' ? 'a Team' : 'an Athlete' }}"
        [searchable]="false"
        class="team-list__filters mb-20"
        id="team1Filter"
        [class.input--error]="fhs.hasError(teamsForm, '0')"
        appendTo="body"
      >
      </ng-select>
      <ng-select
        *ngIf="fhs.hasField(teamsForm, '1')"
        [items]="teams"
        bindLabel="name"
        bindValue="value"
        formControlName="1"
        placeholder="Select {{ subject === 'team' ? 'a Team' : 'an Athlete' }}"
        [searchable]="false"
        class="team-list__filters mb-20"
        id="team2Filter"
        [class.input--error]="fhs.hasError(teamsForm, '1')"
        appendTo="body"
      >
      </ng-select>
      <a
        href=""
        class="no-transparency--link text-black underline"
        *ngIf="!fhs.hasField(teamsForm, '1')"
        (click)="showSecondTeam($event)"
        >If you also played with a second team, click here</a
      >
    </form>
    <div *ngIf="summaryErrorMessage" class="flex justify-center items-center mt-20 text-sienna">
      {{ summaryErrorMessage }}
    </div>
    <div class="flex justify-center items-center mt-20">
      <button (click)="close()" class="btn btn-grey mr-5">Cancel</button>
      <button (click)="submit()" class="btn ml-5">Submit</button>
    </div>
  </ng-container>

  <ng-container *ngIf="showConfirmation">
    <div *ngIf="selectedTeams">
      <p><strong>Team Selected: </strong> {{ selectedTeams[0].name }}</p>
      <p *ngIf="selectedTeams?.length === 2"><strong>Team Selected: </strong> {{ selectedTeams[1].name }}</p>
    </div>
    <div class="flex justify-center items-center mt-20">
      <button (click)="goBack()" class="btn btn-grey mr-5" [class.btn-disabled]="processing">Go Back</button>
      <button (click)="confirm()" class="btn ml-5" [class.btn-disabled]="processing">Confirm</button>
    </div>
  </ng-container>
</div>
